/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable max-len */
/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable object-curly-newline */
/* eslint-disable quote-props */
import { TreeListItem } from "../logic/api/CategoryCareerTreeService";
import { CareerInfoClassInfoResponse } from "../logic/api/CareerInfoClassInfoService";
import { UserDetailResponse } from "../logic/api/UserDetailService";
import { UserList } from "../logic/api/UserSelectListService";
import { CareerResultsItem } from "../logic/api/SearchCareerClassListService";

import { Company } from "../logic/companies/Companies";
// import { THUMBNAILS } from "./base64/thumbnails";
import { USER_IMAGE } from "./base64/user";
import { CERTIFICATION } from "./base64/certification";

const random = (seed: number): number => Math.floor(Math.random() * seed);
export const getRandomThumbnail = (): string => ""; // `data:image/png;base64,${THUMBNAILS[random(4) + 1]}`;
export const getRandomBadge = (): string => (random(2) === 0 ? "必須" : "");
const MOCK_GROUP = ["", "損保ジャパン", "SOMPO HD"];
export const getRandomGroupTag = (): string => MOCK_GROUP[random(3)];

const MOCK_DATA = {
    URL: {
        ELEARNING: "./lm-elearning.html",
        MANAGER: "./lm-manager.html",
    },

    // 会社情報の定義
    COMPANIES: {
        // デフォルト
        default: {
            ui: {
                layout: "1",
                title: "SLH-logo.svg",
                background: "none",
                agreementContents: ["【利用規約】"],
            },
            menu: { administrator: true, search: true, skill: true, information: true, user: true },
        },
    } as { [companyId: string]: Company },

    // /login
    LOGIN: {
        accessToken: "123",
        refreshToken: "abc",
    },

    // Home.SOMPO NEWS
    SOMPO_NEWS: [],

    // Home.情報発信
    SUBMISSION: [],

    USER: {
        IMAGE: USER_IMAGE,
        SELECT_LIST: [],
        CAREERS: {
            ON_GOING: {
                EL: [],
                GT: [],
                DL: [],
                SK: [],
            },
            RESULTS: {
                EL: [],
                GT: [],
            },
        },
        SKILL_MAP: {
            ON_GOING: [],
            MENUS: [],
            CAREERS: [],
            QUALIFICATIONS: [],
            CURRICULUMS: [],
            FIELD: {},
            DATA: {},
            CELL: {},
        },

        APPLICATIONS: {
            SKILL: [],
        },
        RECOMMEND: [],
    },
    INFORMATION: {
        whatsNewList: [],
        msgList: [],
    },
    TRAINING: [{ rows: [] }] as { rows: CareerResultsItem[] }[],
    CAREER: [] as CareerInfoClassInfoResponse[],
    QUALIFICATION: [],
    CURRICULUM: [],
    CURRICULUM_DETAIL: [],
    RESULT_SK_GRID: {},
    ASSESSMENT_RESULT_LIST: {},
    USER_SELECT_LIST: { userList: [] } as UserList,
    USER_DETAIL: {
        generalistsj: {} as UserDetailResponse,
    } as { [loginId: string]: UserDetailResponse },
    CATEGORY_TREE: [
        {
            careerType: 0,
            checkBoxDisplayFlg: false,
            hasChildren: true,
            id: "#0",
            level: "",
            parent: "",
            text: "研修",
            type: 0,
            children: [],
        },
    ] as TreeListItem[],

    // 修了証明書(認定書)のPDFデータ：Base64エンコード
    CERTIFICATION,
};

export default MOCK_DATA;
